<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", [
    _c(
      "div",
      { staticClass: "under-review-page" },
      [
        _c(
          "div",
          { staticClass: "reload-page-btn" },
          [
            _c(
              "b-button",
              { staticClass: "btn-icon", attrs: { variant: "flat-primary" } },
              [
                _c("feather-icon", { attrs: { icon: "RotateCwIcon" } }),
                _c("span", { staticClass: "align-middle ml-1" }, [
                  _vm._v(_vm._s(_vm.$t("Kyc.Refresh"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("UnderReview"),
        _c("div", { staticClass: "under-review-txt" }, [
          _vm._v(_vm._s(_vm.$t("Kyc.Under-Review"))),
        ]),
        _c("div", { staticClass: "under-review-desc" }, [
          _vm._v(" " + _vm._s(_vm.$t("Kyc.Verification-Under-Review")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "capture-btn" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  to: {
                    name: "home",
                    params: { lang: this.lang || undefined },
                  },
                  variant: "primary",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("Kyc.Go-Home")) + " ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/kyc/UnderReview.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_under_review_svg from '@/assets/rashi-coin/under-review.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default ({
  render,
  staticRenderFns,
  components: {
    BCard: bootstrapvue["BCard"],
    UnderReview: assets_rashi_coin_under_review_svg,
    BButton: bootstrapvue["BButton"]
  },
  data() {
    return {
      lang: this.$route.params.lang
    };
  }
});

//# sourceURL=webpack:///./src/views/kyc/UnderReview.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

